import { ActionTree } from 'vuex';
import {
  EDocumentContentAction,
  EDocumentContentMutation,
} from '@/document-view/document-content/store/document-content.constants';
import { IDocumentContentState } from '@/document-view/document-content/store/document-content.types';
import { RootState } from '@/store/store';

export const actions: ActionTree<IDocumentContentState, RootState> = {
  [EDocumentContentAction.SetPageWidth]({ commit }, pageWidth: number) {
    commit(EDocumentContentMutation.SetPageWidth, pageWidth);
  },
};
